import { ILoginService } from '../../services/session/loginService';
import { tenantIdName } from '../../config/constants';
import { getServices } from '../../infra/commonInitializer';
import { LoginInputType } from '../../infra/commonInitializer/types';
import { AuthContextEnum } from '../../services/authTokenService';
import authContextEnumToTenantLevel from '../../services/authTokenService/utils/authContextEnumToTenantLevel';
import { ISessionService } from '../../services/session';
import ITenantHandlerService from '../../services/tenantHandler/ITenantHandlerService';
import { getCookie } from '../../utils/cookies';
import { getStratusAccessToken } from '../../utils/getStratusAccessToken';
import { decodeJWTPayload } from '../../utils/tokenUtils/JWTUtils';
import { TokenType, UserContextEnum } from '../types';

let _sessionService: ISessionService;
let _tenantHandlerService: ITenantHandlerService;
let _loginService: ILoginService;

export default async function authProvider(loginInput?: LoginInputType) {
  return {
    _setSessionService: (sessionService: ISessionService): void => {
      _sessionService = sessionService;
    },

    _setTenantHandlerService: (
      tenantHandlerService: ITenantHandlerService
    ): void => {
      _tenantHandlerService = tenantHandlerService;
    },

    _setLoginService: (loginService: ILoginService): void => {
      _loginService = loginService;
    },

    getAccessToken: async (forceRefresh?: boolean): Promise<string> => {
      const { authProviderService } = getServices();
      return authProviderService.getAccessToken(forceRefresh);
    },
    getIDToken: async (): Promise<string> => {
      return _sessionService.getIdToken();
    },

    /**
     * @deprecated Use v2.onTokenExchangeRequired() instead. Soon, v1.authProvider namespace will be deprecated.
     */
    onTokenExchangeRequired: async (
      userContext: UserContextEnum = UserContextEnum.organization,
      tenantId?: string
    ): Promise<void> => {
      console.warn(
        'This method is deprecated. Use v2.onTokenExchangeRequired() instead. Soon, v1.authProvider namespace will be deprecated.'
      );
      await _sessionService.refresh();

      const _tenantId = tenantId || getCookie(tenantIdName);
      let authContext;
      switch (userContext) {
        case UserContextEnum.customer:
          authContext = AuthContextEnum.subtenant;
          break;
        default:
          authContext = AuthContextEnum.tenant;
          break;
      }

      const level = authContextEnumToTenantLevel(authContext);
      await _tenantHandlerService.setTenant(_tenantId, level, {
        reload: false
      });
    },

    forceLogin: async () => {
      return new Promise(() => {
        _loginService.redirectToLogin({ forceLogin: true });
      });
    },

    getDecodedUserStratusJWTPayload: (
      cookie = TokenType.stratusAccessToken
    ): any => {
      const userToken = getStratusAccessToken(cookie);
      if (!userToken) return undefined;

      return decodeJWTPayload(userToken);
    }
  };
}
